<template>
    <v-card class="panelBlock pending-requests">
        <v-flex tag="span" class="pending-requests__title">
            {{networkConstants.PENDING_REQUESTS}} <small>{{pendingRequests}} {{networkConstants.PENDING_REQUESTS}}</small>
        </v-flex>
        <v-flex class="inner-scrollbar pending-requests__body" v-if="requestedJoineeList.length > 0">
            <v-flex
                class="pending-requests__list"
                v-for="(joinee,i) in requestedJoineeList"
                :key="i">
                <figure><img :src="joinee.personProfileImageUrl" :onerror="imageErrorFallback(joinee.fallbackPersonProfileImageUrl)" /></figure>
                <strong>{{joinee.personName}}</strong>
                <small>{{joinee.networkName}}</small>
                <v-flex class="pending-requests__actions">
                    <v-btn
                        v-if="joinee.approvalStatus === 'P'"
                        small
                        :disabled="joinee.approvalInProgress"
                        class="primary_btn transparent"
                        data-qe-id="network_deny-request_btn"
                        @click="approveRequest(joinee,false)">{{networkConstants.DENY}}</v-btn>
                    <em class="failure__text" v-if="joinee.approvalStatus ==='R'">{{networkConstants.DENY_MESSAGE}}</em>
                    <v-btn
                        :loading="joinee.approvalInProgress"
                        v-if="joinee.approvalStatus === 'P'"
                        small
                        class="primary_btn"
                        data-qe-id="network_approve-request_btn"
                        @click="approveRequest(joinee,true)">{{networkConstants.APPROVE}}</v-btn>
                    <em class="success__text" v-if="joinee.approvalStatus ==='A'">{{networkConstants.APPROVE_MESSAGE}}</em>
                </v-flex>

            </v-flex>
        </v-flex>

        <v-flex class="inner-scrollbar pending-requests__body" v-else>
            <v-flex text-xs-center pt-2>{{networkConstants.NO_PENDING_REQUESTS}}</v-flex>
        </v-flex>

        <v-dialog
            scrollable
            v-model="isRejectedReason"
            content-class="small">
            <v-card class="custom-dailog">
                <v-card-title>
                    <v-layout align-center justify-space-between>
                        <div>{{networkConstants.REJECTED_REASON}}</div>
                        <i class="fas fa-times" data-qe-id="reject-reason_popup_cancel_btn" @click="cancelDialog()"></i>
                    </v-layout>
                </v-card-title>
                <v-card-text>
                    <v-flex class="reject_reason__cont">
                        <v-textarea
                            v-model="rejectedReason"
                            autofocus
                            maxlength="255"
                            data-qe-id="network_deny-reason_input"
                            counter="255">
                        </v-textarea>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-flex
                        xs12
                        text-xs-right
                        pr-3>
                        <v-btn
                            @click="cancelDialog()"
                            data-qe-id="network-request_cancel_btn"
                            class="primary_btn transparent">
                            {{appCommonConstants.CANCEL}}
                        </v-btn>
                        <v-btn
                            :loading="denyInProgress"
                            @click="requestAction()"
                            :disabled="rejectedReason.length === 0"
                            data-qe-id="network-request_save_btn"
                            class="primary_btn">
                            {{appCommonConstants.SAVE}}
                        </v-btn>
                    </v-flex>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { storeAction } from '../../store/storeActions.constant';
    import { storeGetters } from '../../store/storeGetters.constant';
    import { networkConstants } from '../ChapterPage/communityCommon.constant';
    import StatusOverlay from '../StatusOverlay/StatusOverlay';
    import { appCommonConstants, promiseHandler } from "../appCommon.constants";
    import { imageErrorFallback } from "../../common/utils/utils";

    export default {
        name: 'NetworkJoinees',
        components: {
            StatusOverlay,
        },
        created() {
            this.getNetworkJoinees();
        },
        data: () => ({
            denyInProgress: false,
            networkConstants,
            appCommonConstants,
             objApproveRequest: {
                RequestId: '',
                RequestStatus: '',
                RejectionReason: '',
            },
            isRejectedReason: false,
            rejectedReason: '',
            rejectedObject: {
                obj: [],
                approvalStatus: false,
            },

        }),
        methods: {
            ...mapActions({
                getNetworkJoinees: `network/${storeAction.getAllRequestedJoinees}`,
                approveJoineeRequest: `network/${storeAction.approveRequest}`,
            }),
            imageErrorFallback,
            promiseHandler,
            approveRequest(objRequest, value) {
                this.rejectedObject.obj = objRequest;
                this.rejectedObject.approvalStatus = value;
                if (value) {
                    this.requestAction();
                } else {
                    this.rejectedReason = '';
                    this.isRejectedReason = true;
                }
            },
            async requestAction() {
                this.objApproveRequest = {};
                this.objApproveRequest.CommunityId = this.rejectedObject.obj.communityId;
                this.objApproveRequest.RequestId = this.rejectedObject.obj.id;
                this.objApproveRequest.RequestStatus = this.rejectedObject.approvalStatus ? 'A' : 'R';
                this.objApproveRequest.RejectionReason = this.rejectedObject.approvalStatus ? '' : this.rejectedReason;
                this.denyInProgress = this.objApproveRequest.RequestStatus === 'R';
                this.rejectedObject.obj.approvalInProgress = this.objApproveRequest.RequestStatus === 'A';
                const response = await this.promiseHandler(this.approveJoineeRequest(JSON.parse(JSON.stringify(this.objApproveRequest))));
                if (response.ok) {
                    this.isRejectedReason = false;
                    this.objApproveRequest = {};
                    this.requestedJoineeList.find(r => r.id === this.rejectedObject.obj.id).approvalStatus = this.rejectedObject.approvalStatus === true ? 'A' : 'R';
                    this.$emit('onNetworkJoined', this.networkConstants.APPROVED_INVITE_SUCCESSFULLY);
                } else {
                    this.$emit('onNetworkJoined', this.networkConstants.ERROR_WHILE_APPROVING);
                }
                this.denyInProgress = false;
                this.rejectedObject.obj.approvalInProgress = false;
            },
            cancelDialog() {
                this.isRejectedReason = false;
                this.$emit('onNetworkJoined', this.networkConstants.ERROR_WHILE_APPROVING);
            },
        },
        computed: {
            ...mapGetters('network', [storeGetters.requestedJoineeList], [storeGetters.resultApproveRequest]),
            pendingRequests() {
                return this.requestedJoineeList.filter(joinee => joinee.approvalStatus === 'P').length;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";

    .pending-requests {
        &__title {
            display: block;
            padding: 15px;
            border-bottom: 2px solid rgba($ypo_blue, 0.1);
            position: relative;
            color: $ypo_blue;
            margin-bottom: 10px;

            small {
                position: absolute;
                right: 15px;
                font-size: 14px;
            }
        }

        &__list {
            padding: 5px 250px 15px 80px;
            border-bottom: 2px solid rgba($ypo_blue, 0.05);
            position: relative;
            margin: 10px;

            figure {
                width: 50px;
                height: 50px;
                overflow: hidden;
                border-radius: 50%;
                position: absolute;
                left: 15px;
                top: 0;
                bottom: 0;

                img {
                    max-width: 100%;
                }
            }

            strong {
                display: block;
                opacity: 0.6;
                color: $ypo_blue;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }

            small {
                color: $ypo_blue;
                opacity: 0.5;
            }

            .pending-requests__actions {
                position: absolute;
                right: 0;
                top: 0px;
            }
        }

        &__body {
            max-height: 500px;
            overflow-y: auto;
            margin-bottom: 20px;

            em {
                font-style: normal;

                font-size: 12px;
                font-weight: 600;
                position: relative;
                top: 10px;
                right: 10px;

                &.success__text {
                    color: $ypo-green;
                }

                &.failure__text {
                    color: $ypo-red;
                }
            }
        }
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";

    .reject_reason__cont {
        .v-input {
            padding-top: 0px;

            &__slot {
                font-size: 14px;
                border: 1px solid $ypo-medium-gray;
                border-radius: 3px;
                padding: 5px 10px;

                &:before,
                &:after {
                    display: none;
                }
            }
        }
    }
</style>
